// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import { injectGlobal } from 'styled-components';
import createHistory from 'history/createBrowserHistory';
import { StripeProvider } from 'react-stripe-elements';

import configureStore from './store';
import Routes from './routes';
import registerServiceWorker from './registerServiceWorker';
import BugsnagErrorBoundary from './utils/bugsnag';

import GraphikLight from './assets/fonts/Graphik-Light.woff';
import GraphikLight2 from './assets/fonts/Graphik-Light.woff2';
import GraphikMedium from './assets/fonts/Graphik-Medium.woff';
import GraphikMedium2 from './assets/fonts/Graphik-Medium.woff2';
import GraphikSemibold from './assets/fonts/Graphik-Semibold.woff';
import GraphikSemibold2 from './assets/fonts/Graphik-Semibold.woff2';

const history = createHistory();
const store = configureStore(history);

// https://github.com/stripe/react-stripe-elements#loading-stripejs-asynchronously
class App extends Component<*, *> {
  state = { stripe: null };

  componentDidMount() {
    const stripeApiKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY;

    if (window.Stripe) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        stripe: window.Stripe(stripeApiKey),
      });
    } else {
      // $FlowFixMe
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({ stripe: window.Stripe(stripeApiKey) });
      });
    }
  }

  render() {
    const { stripe } = this.state;
    return (
      <BugsnagErrorBoundary>
        <Provider store={store}>
          <StripeProvider stripe={stripe}>
            <AppContainer>
              <Routes history={history} />
            </AppContainer>
          </StripeProvider>
        </Provider>
      </BugsnagErrorBoundary>
    );
  }
}

const render = () => {
  // $FlowFixMe
  ReactDOM.render(<App />, document.getElementById('root'));
};

render();

// Webpack Hot Module Replacement API
// $FlowFixMe
if (module.hot) {
  module.hot.accept('./routes', () => {
    render();
  });
}

registerServiceWorker();

// eslint-disable-next-line no-unused-expressions
injectGlobal`
  @font-face {
    font-family: 'Graphik';
    font-style: normal;
    font-weight: 100;
    src: url(${GraphikLight}) format('woff2'),
         url(${GraphikLight2}) format('woff');
  }

  @font-face {
    font-family: 'Graphik';
    font-style: normal;
    font-weight: 400;
    src: url(${GraphikMedium}) format('woff2'),
         url(${GraphikMedium2}) format('woff');
  }

  @font-face {
    font-family: 'Graphik';
    font-style: normal;
    font-weight: 700;
    src: url(${GraphikSemibold}) format('woff2'),
         url(${GraphikSemibold2}) format('woff');
  }

  html {
    box-sizing: border-box;
    font-size: 16px;
    height: 100%;
  }

  body {
    font-family: 'Graphik';
    margin: 0;
    position: relative;
    line-height: 1;
    min-height: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  #root {
    min-height: 100vh;
    position: relative;
  }
`;



// WEBPACK FOOTER //
// ./src/index.js